import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';
import { FancyDropdownMenuItem } from 'dpl/components/FancyDropdown';

export default function BreedSearchResultItem({
  coverPhotoUrl,
  inDropdown,
  name,
  url,
  onClick
}) {
  const timeoutRef = useRef(null);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  function handleLinkClick() {
    setIsClicked(true);

    timeoutRef.current = setTimeout(() => {
      setIsClicked(false);
      onClick?.();
    }, 300);
  }

  const coverPhoto = (
    <SmartImage
      lazy
      crop
      width="48px"
      height="48px"
      loadingClass="bg-light-gray"
      className="br3"
      src={coverPhotoUrl}
    />
  );

  if (!inDropdown) {
    return (
      <a
        href={url}
        className={classnames(
          'BreedSearchResultItem db w-100 flex items-center ph5 pv2 transition-bg',
          {
            'bg-subtle-gray': isClicked
          }
        )}
        onClick={handleLinkClick}
      >
        {coverPhotoUrl && <div className="f0 mr4">{coverPhoto}</div>}
        <span className="truncate flex-auto font-16">{name}</span>
      </a>
    );
  }

  return (
    <FancyDropdownMenuItem
      className="transition-bg"
      itemKey={url}
      selectedClassName="bg-subtle-gray br2"
    >
      <button
        type="button"
        className="BreedSearchResultItem db w-100 flex items-center ph4 pv3"
        onClick={onClick}
      >
        {coverPhotoUrl && <div className="f0 mr3">{coverPhoto}</div>}
        <span className="truncate flex-auto font-14 fw-medium">{name}</span>
      </button>
    </FancyDropdownMenuItem>
  );
}

BreedSearchResultItem.propTypes = {
  coverPhotoUrl: PropTypes.string,
  inDropdown: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

BreedSearchResultItem.defaultProps = {
  coverPhotoUrl: null,
  onClick: null
};
